import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak
} from "keycloak-angular";
import { KeycloakConfig, KeycloakInitOptions } from "keycloak-js";
import { Environment } from "../models/environment.model";
import { TestService } from "../services/test.service";
import { Provider } from "@angular/core";

export interface HbKeycloakOptions {
  initKeycloak: boolean;
  includeE2eTokens: boolean;
  environment: Environment;
}

export function provideHbKeycloak(config: KeycloakConfig, hbKeycloakOptions: HbKeycloakOptions): Provider {
  return [
    provideKeycloak({
      config,
      initOptions: getInitOptions(hbKeycloakOptions),
      providers: [
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [createInterceptorCondition<IncludeBearerTokenCondition>({ urlPattern: /.*/ })],
        },
      ],
    }),
  ];
}

export function getInitOptions({ initKeycloak, includeE2eTokens, environment }: HbKeycloakOptions): KeycloakInitOptions | undefined {
  if (!initKeycloak) {
    return undefined;
  }

  const baseInitOptions: KeycloakInitOptions = {
    pkceMethod: "S256",
    onLoad: "login-required",
    checkLoginIframe: false,
    redirectUri: environment.redirectUri,
  };

  if (includeE2eTokens) {
    return {
      ...baseInitOptions,
      token: TestService.accessToken,
      idToken: TestService.idToken as string,
      refreshToken: TestService.refreshToken,
    };
  }

  return baseInitOptions;
}
